module.exports = __webpack_public_path__ + "img/ck.22bf8119.svg";